import * as React from "react";

import Tabs from '@mui/material/Tabs';
import Container from '@mui/material/Container';

import WaitOrders from "./WaitOrders.jsx";
import WaitAssistance from "./WaitAssistance.jsx"
import NotificationTab from "../components/NotificationTab.jsx";

const ORDER_INDEX = 0;
const ASSISTANCE_INDEX = 1;

// page mamnages which tab the wait staff is on within their interface
// also enables notification dots to be presented
export default function WaitStaff() {

  //manages the state of the tabs, what tab is currently selected
  const [index, setIndex] = React.useState(ORDER_INDEX);


  //manages the state of the notifications, what tab currently has a notificiation
  const [orderNotification, setOrderNote] = React.useState(false);
  const [assistNotification, setAssistNote] = React.useState(false);

  //Handle tab change
  const handleChange = (event, newIndex) => {
    //change the index to display different content
    setIndex(newIndex);

    if (newIndex == ORDER_INDEX) {setOrderNote(false)}
    else if (newIndex == ASSISTANCE_INDEX) {setAssistNote(false)}
    
  };  

  return (
    <Container>
        <Tabs value = {index} textColor="inherit" onChange={handleChange} centered TabIndicatorProps={{
          style: {
            backgroundColor: "black",
          }
        }}>
          <NotificationTab label="Orders" state={orderNotification} sx={{width: 150, fontSize: "1rem", color: "black"}}/>          
          <NotificationTab label="Assistance" state={assistNotification} sx={{width: 150, fontSize: "1rem", color: "black"}}/>
        </Tabs>
        <div hidden={ORDER_INDEX !== index}>
          <WaitOrders setNotification={setOrderNote}></WaitOrders>
        </div>
        <div hidden={ASSISTANCE_INDEX !== index}>
          <WaitAssistance setNotification={setAssistNote}></WaitAssistance>
        </div>
    </Container>
  );
};